<template>
  <div style="position: fixed; transform: translateY(10000px)">
    <div id="eform_container" style="height: 1100px; width: 850px; position: relative" ref="el">
      <form id="inputForm" action="">
        <div id="page_1" class="page_container ui-droppable" style="width: 850px; height: 1100px">
          <img
            id="gen_backgroundImage1"
            class="gen-layer1"
            :src="bg"
            style="width: 100%; height: auto; z-index: 0"
          />
          <div class="input_elements">
            <!--Hidden Elements for OrderingPhysician & PhoneFaxInfo-->
            <input name="current_user" id="current_user" oscardb="current_user" type="hidden" />
            <input
              name="current_user_ohip_no"
              id="current_user_ohip_no"
              oscardb="current_user_ohip_no"
              type="hidden"
            />
            <input
              name="clinic_addressLine"
              id="clinic_addressLine"
              oscardb="clinic_addressLine"
              type="hidden"
            />
            <input name="clinic_city" id="clinic_city" oscardb="clinic_city" type="hidden" />
            <input
              name="clinic_province"
              id="clinic_province"
              oscardb="clinic_province"
              type="hidden"
            />
            <input name="clinic_postal" id="clinic_postal" oscardb="clinic_postal" type="hidden" />

            <input name="clinic_phone" id="clinic_phone" oscardb="clinic_phone" type="hidden" />
            <input name="clinic_fax" id="clinic_fax" oscardb="clinic_fax" type="hidden" />

            <!--Hidden Elements for getSignatureID()-->
            <input
              id="current_logged_in_user_type"
              name="current_logged_in_user_type"
              type="hidden"
              oscardb="current_logged_in_user_type"
            />
            <input
              id="current_logged_in_user_id"
              name="current_logged_in_user_id"
              type="hidden"
              oscardb="current_logged_in_user_id"
            />
            <input
              name="appt_provider_id"
              id="appt_provider_id"
              oscardb="appt_provider_id"
              type="hidden"
            />
            <input
              id="doctor_provider_no"
              name="doctor_provider_no"
              type="hidden"
              oscardb="doctor_provider_no"
            />
            <input
              type="hidden"
              name="medical_history"
              id="medical_history"
              oscardb="medical_history"
              value=""
            />
            <input
              type="hidden"
              name="druglist_generic"
              id="druglist_generic"
              oscardb="druglist_generic"
              value=""
            />

            <div
              id="gen_widgetId1"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 301px;
                height: 16px;
                position: absolute;
                z-index: 8;
                top: 102.467px;
                left: 29.8667px;
              "
            >
              <input
                type="text"
                class="gen_input noborder regular_input"
                oscardb="current_user"
                id="gen_inputId1"
                name="gen_inputId1"
                value="Saeed, Tuaha"
              />
            </div>
            <div
              id="gen_widgetId2"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 302px;
                height: 78px;
                position: absolute;
                z-index: 9;
                top: 120px;
                left: 28.8667px;
              "
            >
              <textarea
                style="resize: none"
                class="gen_input noborder"
                id="gen_inputId2"
                name="gen_inputId2"
              ></textarea>
            </div>
            <div
              id="gen_widgetId3"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 173px;
                height: 16px;
                position: absolute;
                z-index: 10;
                top: 211.467px;
                left: 27.8667px;
              "
            >
              <textarea
                class="gen_input noborder"
                oscardb="current_user_ohip_no"
                id="gen_inputId3"
                name="gen_inputId3"
              ></textarea>
            </div>
            <div
              id="gen_widgetId4"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 123px;
                height: 16px;
                position: absolute;
                z-index: 11;
                top: 211.467px;
                left: 207.867px;
              "
            >
              <input
                type="text"
                class="gen_input noborder regular_input"
                oscardb="current_user_cpsid"
                id="gen_inputId4"
                name="gen_inputId4"
                style="left: 0; top: 0; font-size: 0.8rem"
                value="053641"
              />
            </div>
            <!-- PHYSICIAN CONTACT NO -->
            <div
              id="gen_widgetId5"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 256px;
                height: 16px;
                position: absolute;
                z-index: 12;
                top: 172.467px;
                left: 335.867px;
              "
            >
              <input
                type="text"
                class="gen_input noborder"
                oscardb="clinic_phone"
                id="gen_inputId5"
                name="gen_inputId5"
                value="705-328-2019"
                style="font-size: 0.9rem"
              />
            </div>
            <!-- HEALTH CARD NUMBER -->
            <div
              id="gen_widgetId6"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 201px;
                height: 16px;
                position: absolute;
                z-index: 13;
                top: 214.467px;
                left: 332.867px;
              "
            >
              <input
                type="text"
                class="gen_input noborder structured_input"
                oscardb="hinc"
                id="gen_inputId6"
                name="gen_inputId6"
                v-model="hcn"
              />
            </div>
            <!-- version code -->
            <div
              id="gen_widgetId7"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 37px;
                height: 16px;
                position: absolute;
                z-index: 14;
                top: 214.467px;
                left: 538.867px;
              "
            >
              <input
                type="text"
                class="gen_input noborder structured_input"
                oscardb="hinversion"
                id="gen_inputId7"
                name="gen_inputId7"
                v-model="versionCode"
                style="letter-spacing: 9px"
              />
            </div>
            <div
              id="gen_widgetId8"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 15px;
                height: 15px;
                position: absolute;
                z-index: 15;
                top: 215.8px;
                left: 580.867px;
              "
            >
              <input
                type="checkbox"
                class="gen_input xBox gender_precheck_M"
                autocomplete="off"
                style="font-size: 12px"
                id="gen_inputId8"
                name="gen_inputId8"
                :checked="sex === 'male'"
              />
            </div>
            <!-- SEX - FEMALE -->
            <div
              id="gen_widgetId9"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 15px;
                height: 15px;
                position: absolute;
                z-index: 16;
                top: 215.8px;
                left: 621.867px;
              "
            >
              <input
                type="checkbox"
                class="gen_input xBox gender_precheck_F"
                autocomplete="off"
                style="font-size: 12px"
                id="gen_inputId9"
                name="gen_inputId9"
                :checked="sex === 'female'"
              />
            </div>
            <!-- DATE OF BIRTH -->
            <div
              id="gen_widgetId10"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 164px;
                height: 16px;
                position: absolute;
                z-index: 17;
                top: 215.467px;
                left: 658.867px;
              "
            >
              <input
                type="text"
                class="gen_input noborder structured_input"
                oscardb="dobc2"
                id="gen_inputId10"
                name="gen_inputId10"
                v-model="dob"
              />
            </div>
            <!-- HCN PROVINCE -->
            <div
              id="gen_widgetId11"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 38px;
                height: 16px;
                position: absolute;
                z-index: 18;
                top: 251.467px;
                left: 334.867px;
              "
            >
              <input
                type="text"
                class="gen_input noborder structured_input"
                oscardb="province"
                id="gen_inputId11"
                name="gen_inputId11"
                v-model="healthCardProvince"
                style="letter-spacing: 9px"
              />
            </div>
            <div
              id="gen_widgetId12"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 243px;
                height: 16px;
                position: absolute;
                z-index: 19;
                top: 251.467px;
                left: 374.867px;
              "
            >
              <input
                type="text"
                class="gen_input noborder"
                id="gen_inputId12"
                name="gen_inputId12"
              />
            </div>
            <!-- PATIENT PHONE -->
            <div
              id="gen_widgetId13"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 200px;
                height: 16px;
                position: absolute;
                z-index: 20;
                top: 250.467px;
                left: 621.867px;
              "
            >
              <input
                type="text"
                class="gen_input noborder regular_input"
                oscardb="phone"
                id="gen_inputId13"
                name="gen_inputId13"
                v-model="patientPhone"
                style="left: 0; top: 0; font-size: 0.9rem; height: 16px"
              />
            </div>
            <!-- PATIENT LAST NAME -->
            <div
              id="gen_widgetId14"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 488px;
                height: 16px;
                position: absolute;
                z-index: 21;
                top: 288.467px;
                left: 334.867px;
              "
            >
              <input
                type="text"
                class="gen_input noborder structured_input"
                oscardb="patient_nameL"
                id="gen_inputId14"
                name="gen_inputId14"
                v-model="patientLastName"
              />
            </div>
            <!-- PATIENT FIRST NAME -->
            <div
              id="gen_widgetId15"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 242px;
                height: 16px;
                position: absolute;
                z-index: 22;
                top: 326.467px;
                left: 333.867px;
              "
            >
              <input
                type="text"
                class="gen_input noborder structured_input"
                oscardb="patient_nameF"
                id="gen_inputId15"
                name="gen_inputId15"
                v-model="patientFirstName"
              />
            </div>

            <div
              id="gen_widgetId16"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 246px;
                height: 16px;
                position: absolute;
                z-index: 23;
                top: 326.467px;
                left: 577.867px;
              "
            >
              <input
                type="text"
                class="gen_input noborder"
                id="gen_inputId16"
                name="gen_inputId16"
              />
            </div>
            <!-- PATIENT ADDRESS -->
            <div
              id="gen_widgetId17"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 222px;
                height: 48px;
                position: absolute;
                z-index: 24;
                top: 355.35px;
                left: 334.867px;
              "
            >
              <div style="font-size: 0.8rem; line-height: 1.2">
                <div v-for="line in address" :key="line">
                  {{ line }}
                </div>
              </div>
            </div>
            <div
              id="gen_widgetId18"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 260px;
                height: 93px;
                position: absolute;
                z-index: 25;
                top: 345.35px;
                left: 561.867px;
              "
            >
              <textarea
                style="resize: none"
                class="gen_input noborder"
                id="gen_inputId18"
                name="gen_inputId18"
              ></textarea>
            </div>
            <div
              id="gen_widgetId19"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 15px;
                height: 15px;
                position: absolute;
                z-index: 27;
                top: 249.8px;
                left: 277.867px;
              "
            >
              <input
                type="text"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 12px"
                id="gen_inputId19"
                name="gen_inputId19"
              />
            </div>
            <div
              id="gen_widgetId20"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 15px;
                height: 15px;
                position: absolute;
                z-index: 26;
                top: 250.8px;
                left: 125.867px;
              "
            >
              <input
                type="text"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 12px"
                id="gen_inputId20"
                name="gen_inputId20"
              />
            </div>

            <!-- OHIP INSURED-->

            <div
              id="INSURANCE"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 15px;
                height: 15px;
                position: absolute;
                z-index: 28;
                top: 250.8px;
                left: 26.8667px;
              "
            >
              <input
                type="checkbox"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 12px; top: 0; left: 0; position: absolute"
                id="gen_inputId21"
                name="gen_inputId21"
                value="X"
                :checked="values.ohipInsured"
              />
            </div>
            <!-- ADDITIONAL CLINICAL INFORMATION -->
            <div
              id="ADDITIONAL_INFO"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 305px;
                height: 61px;
                position: absolute;
                z-index: 29;
                top: 282.35px;
                left: 26.8667px;
              "
            >
              <textarea
                style="resize: none"
                class="gen_input noborder regular_input"
                id="gen_inputId22"
                name="gen_inputId22"
                v-model="values.additionalInfo"
              ></textarea>
            </div>
            <div
              id="gen_widgetId23"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 15px;
                height: 15px;
                position: absolute;
                z-index: 30;
                top: 341.8px;
                left: 26.8667px;
              "
            >
              <input
                type="text"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 12px"
                id="gen_inputId23"
                name="gen_inputId23"
              />
            </div>
            <div
              id="gen_widgetId24"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 302px;
                height: 76px;
                position: absolute;
                z-index: 31;
                top: 362.35px;
                left: 27.8667px;
              "
            >
              <textarea
                style="resize: none"
                class="gen_input noborder"
                id="gen_inputId24"
                name="gen_inputId24"
              ></textarea>
            </div>
            <div
              id="gen_widgetId25"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 32;
                top: 470.8px;
                left: 26px;
              "
            >
              <input
                type="checkbox"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId25"
                name="gen_inputId25"
                v-model="values.tests.glucose"
              />
            </div>
            <div
              id="gen_widgetId26"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 33;
                top: 488.8px;
                left: 26px;
              "
            >
              <input
                type="checkbox"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId26"
                name="gen_inputId26"
                v-model="values.tests.hb1ac"
              />
            </div>
            <!-- creatinine -->
            <div
              id="gen_widgetId27"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 35;
                top: 506px;
                left: 26px;
              "
            >
              <input
                type="checkbox"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId27"
                name="gen_inputId27"
                v-model="values.tests.creatinine"
              />
            </div>
            <div
              id="gen_widgetId28"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 50;
                top: 472px;
                left: 158px;
              "
            >
              <input
                type="text"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId28"
                name="gen_inputId28"
              />
            </div>
            <div
              id="gen_widgetId29"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 51;
                top: 472px;
                left: 244px;
              "
            >
              <input
                type="checkbox"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId29"
                name="gen_inputId29"
                v-model="values.tests.fasting"
              />
            </div>
            <div
              id="gen_widgetId30"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 36;
                top: 523px;
                left: 26px;
              "
            >
              <input
                type="text"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId30"
                name="gen_inputId30"
              />
            </div>
            <!-- sodium -->
            <div
              id="gen_widgetId31"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 37;
                top: 540px;
                left: 26px;
              "
            >
              <input
                type="checkbox"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId31"
                name="gen_inputId31"
                v-model="values.tests.sodium"
              />
            </div>
            <!-- potassium -->
            <div
              id="gen_widgetId32"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 38;
                top: 557px;
                left: 26px;
              "
            >
              <input
                type="checkbox"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId32"
                name="gen_inputId32"
                v-model="values.tests.potassium"
              />
            </div>
            <!-- ALT -->
            <div
              id="gen_widgetId33"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 39;
                top: 574px;
                left: 26px;
              "
            >
              <input
                type="checkbox"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId33"
                name="gen_inputId33"
                v-model="values.tests.alt"
              />
            </div>
            <div
              id="gen_widgetId34"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 40;
                top: 592px;
                left: 26px;
              "
            >
              <input
                type="text"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId34"
                name="gen_inputId34"
              />
            </div>
            <div
              id="gen_widgetId35"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 41;
                top: 609px;
                left: 26px;
              "
            >
              <input
                type="text"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId35"
                name="gen_inputId35"
              />
            </div>
            <div
              id="gen_widgetId36"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 42;
                top: 626px;
                left: 26px;
              "
            >
              <input
                type="text"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId36"
                name="gen_inputId36"
              />
            </div>
            <!-- Lipid assesment -->
            <div
              id="gen_widgetId37"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 43;
                top: 657px;
                left: 26px;
              "
            >
              <input
                type="checkbox"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId37"
                name="gen_inputId37"
                v-model="values.tests.lipid_assessment"
              />
            </div>
            <div
              id="gen_widgetId38"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 44;
                top: 694px;
                left: 26px;
              "
            >
              <input
                type="text"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId38"
                name="gen_inputId38"
              />
            </div>
            <div
              id="gen_widgetId39"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 45;
                top: 711px;
                left: 26px;
              "
            >
              <input
                type="text"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId39"
                name="gen_inputId39"
              />
            </div>
            <div
              id="gen_widgetId40"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 46;
                top: 728px;
                left: 26px;
              "
            >
              <input
                type="text"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId40"
                name="gen_inputId40"
              />
            </div>
            <div
              id="gen_widgetId41"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 47;
                top: 745px;
                left: 26px;
              "
            >
              <input
                type="text"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId41"
                name="gen_inputId41"
              />
            </div>
            <div
              id="gen_widgetId42"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 48;
                top: 798px;
                left: 26px;
              "
            >
              <input
                type="text"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId42"
                name="gen_inputId42"
              />
            </div>
            <div
              id="gen_widgetId43"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 49;
                top: 815px;
                left: 26px;
              "
            >
              <input
                type="text"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId43"
                name="gen_inputId43"
              />
            </div>
            <div
              id="gen_widgetId44"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                height: 16px;
                position: absolute;
                z-index: 52;
                width: 30px;
                top: 506.467px;
                left: 173px;
              "
            >
              <input
                type="text"
                class="gen_input noborder"
                id="gen_inputId44"
                name="gen_inputId44"
              />
            </div>
            <div
              id="gen_widgetId45"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                height: 16px;
                position: absolute;
                z-index: 53;
                width: 30px;
                top: 489px;
                left: 173px;
              "
            >
              <input
                type="text"
                class="gen_input noborder"
                id="gen_inputId45"
                name="gen_inputId45"
              />
            </div>
            <div
              id="gen_widgetId46"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                height: 16px;
                position: absolute;
                z-index: 54;
                width: 30px;
                top: 541px;
                left: 172px;
              "
            >
              <input
                type="text"
                class="gen_input noborder"
                id="gen_inputId46"
                name="gen_inputId46"
              />
            </div>
            <div
              id="gen_widgetId47"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                height: 16px;
                position: absolute;
                z-index: 56;
                width: 30px;
                top: 558px;
                left: 172px;
              "
            >
              <input
                type="text"
                class="gen_input noborder"
                id="gen_inputId47"
                name="gen_inputId47"
              />
            </div>
            <div
              id="gen_widgetId48"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                height: 16px;
                position: absolute;
                z-index: 60;
                width: 30px;
                top: 575px;
                left: 172px;
              "
            >
              <input
                type="text"
                class="gen_input noborder"
                id="gen_inputId48"
                name="gen_inputId48"
              />
            </div>
            <div
              id="gen_widgetId49"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                height: 16px;
                position: absolute;
                z-index: 58;
                width: 48px;
                top: 506.467px;
                left: 203px;
              "
            >
              <input
                type="text"
                class="gen_input noborder"
                id="gen_inputId49"
                name="gen_inputId49"
              />
            </div>
            <div
              id="gen_widgetId50"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                height: 16px;
                position: absolute;
                z-index: 59;
                width: 48px;
                top: 489.467px;
                left: 203px;
              "
            >
              <input
                type="text"
                class="gen_input noborder"
                id="gen_inputId50"
                name="gen_inputId50"
              />
            </div>
            <div
              id="gen_widgetId51"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                height: 16px;
                position: absolute;
                z-index: 55;
                width: 48px;
                top: 541.467px;
                left: 202px;
              "
            >
              <input
                type="text"
                class="gen_input noborder"
                id="gen_inputId51"
                name="gen_inputId51"
              />
            </div>
            <div
              id="gen_widgetId52"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                height: 16px;
                position: absolute;
                z-index: 57;
                width: 48px;
                top: 558.467px;
                left: 202px;
              "
            >
              <input
                type="text"
                class="gen_input noborder"
                id="gen_inputId52"
                name="gen_inputId52"
              />
            </div>
            <div
              id="gen_widgetId53"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                height: 16px;
                position: absolute;
                z-index: 61;
                width: 48px;
                top: 575.467px;
                left: 202px;
              "
            >
              <input
                type="text"
                class="gen_input noborder"
                id="gen_inputId53"
                name="gen_inputId53"
              />
            </div>
            <div
              id="gen_widgetId54"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                height: 16px;
                position: absolute;
                z-index: 62;
                width: 48px;
                top: 675.467px;
                left: 274.867px;
              "
            >
              <input
                type="text"
                class="gen_input noborder"
                id="gen_inputId54"
                name="gen_inputId54"
              />
            </div>
            <div
              id="gen_widgetId55"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                height: 16px;
                position: absolute;
                z-index: 63;
                width: 48px;
                top: 694.467px;
                left: 201px;
              "
            >
              <input
                type="text"
                class="gen_input noborder"
                id="gen_inputId55"
                name="gen_inputId55"
              />
            </div>
            <div
              id="gen_widgetId56"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                height: 16px;
                position: absolute;
                z-index: 65;
                width: 48px;
                top: 746.467px;
                left: 130.867px;
              "
            >
              <input
                type="text"
                class="gen_input noborder"
                id="gen_inputId56"
                name="gen_inputId56"
              />
            </div>
            <div
              id="gen_widgetId57"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                height: 16px;
                position: absolute;
                z-index: 64;
                width: 48px;
                top: 746.467px;
                left: 230.867px;
              "
            >
              <input
                type="text"
                class="gen_input noborder"
                id="gen_inputId57"
                name="gen_inputId57"
              />
            </div>
            <div
              id="gen_widgetId58"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                height: 16px;
                position: absolute;
                z-index: 66;
                width: 125px;
                top: 763.467px;
                left: 184px;
              "
            >
              <input
                type="text"
                class="gen_input noborder"
                id="gen_inputId58"
                name="gen_inputId58"
              />
            </div>
            <div
              id="gen_widgetId59"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                height: 16px;
                position: absolute;
                z-index: 67;
                width: 125px;
                top: 780.467px;
                left: 184px;
              "
            >
              <input
                type="text"
                class="gen_input noborder"
                id="gen_inputId59"
                name="gen_inputId59"
              />
            </div>
            <div
              id="gen_widgetId60"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                height: 16px;
                position: absolute;
                z-index: 68;
                width: 199px;
                top: 816.467px;
                left: 133px;
              "
            >
              <input
                type="text"
                class="gen_input noborder"
                id="gen_inputId60"
                name="gen_inputId60"
              />
            </div>
            <div
              id="gen_widgetId61"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                height: 16px;
                position: absolute;
                z-index: 69;
                width: 199px;
                top: 834.467px;
                left: 133px;
              "
            >
              <input
                type="text"
                class="gen_input noborder"
                id="gen_inputId61"
                name="gen_inputId61"
              />
            </div>
            <div
              id="gen_widgetId62"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                height: 16px;
                position: absolute;
                z-index: 70;
                width: 40px;
                top: 852.467px;
                left: 150px;
              "
            >
              <input
                type="text"
                class="gen_input noborder"
                id="gen_inputId62"
                name="gen_inputId62"
              />
            </div>
            <div
              id="gen_widgetId63"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                height: 16px;
                position: absolute;
                z-index: 71;
                width: 40px;
                top: 870.467px;
                left: 150px;
              "
            >
              <input
                type="text"
                class="gen_input noborder"
                id="gen_inputId63"
                name="gen_inputId63"
              />
            </div>
            <div
              id="gen_widgetId64"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                height: 16px;
                position: absolute;
                z-index: 72;
                width: 40px;
                top: 887.467px;
                left: 150px;
              "
            >
              <input
                type="text"
                class="gen_input noborder"
                id="gen_inputId64"
                name="gen_inputId64"
              />
            </div>
            <div
              id="gen_widgetId65"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                height: 16px;
                position: absolute;
                z-index: 73;
                width: 40px;
                top: 852.467px;
                left: 250px;
              "
            >
              <input
                type="text"
                class="gen_input noborder"
                id="gen_inputId65"
                name="gen_inputId65"
              />
            </div>
            <div
              id="gen_widgetId66"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                height: 16px;
                position: absolute;
                z-index: 74;
                width: 40px;
                top: 870.467px;
                left: 250px;
              "
            >
              <input
                type="text"
                class="gen_input noborder"
                id="gen_inputId66"
                name="gen_inputId66"
              />
            </div>
            <div
              id="gen_widgetId67"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                height: 16px;
                position: absolute;
                z-index: 75;
                width: 40px;
                top: 887.467px;
                left: 250px;
              "
            >
              <input
                type="text"
                class="gen_input noborder"
                id="gen_inputId67"
                name="gen_inputId67"
              />
            </div>
            <div
              id="gen_widgetId68"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                height: 50px;
                position: absolute;
                z-index: 76;
                width: 135px;
                top: 997.467px;
                left: 35.8667px;
              "
            >
              <img id="signature" style="position: absolute; height: 50px" :src="signature" />
            </div>
            <div
              id="gen_widgetId69"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                height: 18px;
                position: absolute;
                z-index: 77;
                width: 109px;
                top: 1031.47px;
                left: 221.867px;
              "
            >
              <input
                type="text"
                class="gen_input noborder regular_input"
                oscardb="today2"
                id="gen_inputId69"
                name="gen_inputId69"
                :value="$store.getters.toTimezone().format('YYYY-MM-DD')"
                style="height: 16px; top: 0; left: 0; font-size: 0.9rem"
              />
            </div>
            <!-- CBC -->
            <div
              id="gen_widgetId70"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 78;
                top: 472px;
                left: 332px;
              "
            >
              <input
                type="checkbox"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId70"
                name="gen_inputId70"
                v-model="values.tests.cbc"
              />
            </div>
            <div
              id="gen_widgetId71"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 79;
                top: 489px;
                left: 332px;
              "
            >
              <input
                type="text"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId71"
                name="gen_inputId71"
              />
            </div>
            <div
              id="gen_widgetId72"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 80;
                top: 523px;
                left: 332px;
              "
            >
              <input
                type="text"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId72"
                name="gen_inputId72"
              />
            </div>
            <div
              id="gen_widgetId73"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 81;
                top: 540px;
                left: 332px;
              "
            >
              <input
                type="text"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId73"
                name="gen_inputId73"
              />
            </div>
            <div
              id="gen_widgetId74"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 82;
                top: 557px;
                left: 332px;
              "
            >
              <input
                type="text"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId74"
                name="gen_inputId74"
              />
            </div>
            <div
              id="gen_widgetId75"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 83;
                top: 574px;
                left: 332px;
              "
            >
              <input
                type="text"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId75"
                name="gen_inputId75"
              />
            </div>
            <div
              id="gen_widgetId76"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 84;
                top: 608px;
                left: 332px;
              "
            >
              <input
                type="text"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId76"
                name="gen_inputId76"
              />
            </div>
            <div
              id="gen_widgetId77"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 85;
                top: 659px;
                left: 332px;
              "
            >
              <input
                type="text"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId77"
                name="gen_inputId77"
              />
            </div>
            <div
              id="gen_widgetId78"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 86;
                top: 677px;
                left: 332px;
              "
            >
              <input
                type="text"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId78"
                name="gen_inputId78"
              />
            </div>
            <div
              id="gen_widgetId79"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 87;
                top: 694px;
                left: 332px;
              "
            >
              <input
                type="text"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId79"
                name="gen_inputId79"
              />
            </div>
            <div
              id="gen_widgetId80"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 88;
                top: 711px;
                left: 332px;
              "
            >
              <input
                type="text"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId80"
                name="gen_inputId80"
              />
            </div>
            <div
              id="gen_widgetId81"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 89;
                top: 728px;
                left: 332px;
              "
            >
              <input
                type="text"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId81"
                name="gen_inputId81"
              />
            </div>
            <div
              id="gen_widgetId82"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 91;
                top: 745px;
                left: 332px;
              "
            >
              <input
                type="text"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId82"
                name="gen_inputId82"
              />
            </div>
            <div
              id="gen_widgetId83"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 90;
                top: 762px;
                left: 332px;
              "
            >
              <input
                type="text"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId83"
                name="gen_inputId83"
              />
            </div>
            <div
              id="gen_widgetId84"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 92;
                top: 780px;
                left: 332px;
              "
            >
              <input
                type="text"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId84"
                name="gen_inputId84"
              />
            </div>
            <div
              id="gen_widgetId85"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 93;
                top: 797px;
                left: 332px;
              "
            >
              <input
                type="text"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId85"
                name="gen_inputId85"
              />
            </div>
            <div
              id="gen_widgetId86"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 94;
                top: 816px;
                left: 332px;
              "
            >
              <input
                type="text"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId86"
                name="gen_inputId86"
              />
            </div>
            <div
              id="gen_widgetId87"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 95;
                top: 834px;
                left: 332px;
              "
            >
              <input
                type="text"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId87"
                name="gen_inputId87"
              />
            </div>
            <div
              id="gen_widgetId88"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 96;
                top: 851px;
                left: 332px;
              "
            >
              <input
                type="text"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId88"
                name="gen_inputId88"
              />
            </div>
            <div
              id="gen_widgetId89"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                height: 16px;
                position: absolute;
                z-index: 97;
                width: 48px;
                top: 489.467px;
                left: 471.867px;
              "
            >
              <input
                type="text"
                class="gen_input noborder"
                id="gen_inputId89"
                name="gen_inputId89"
              />
            </div>
            <div
              id="gen_widgetId90"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                height: 16px;
                position: absolute;
                z-index: 98;
                width: 48px;
                top: 711.467px;
                left: 495.867px;
              "
            >
              <input
                type="text"
                class="gen_input noborder"
                id="gen_inputId90"
                name="gen_inputId90"
              />
            </div>
            <div
              id="gen_widgetId91"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                height: 16px;
                position: absolute;
                z-index: 99;
                width: 106px;
                top: 728.467px;
                left: 455.867px;
              "
            >
              <input
                type="text"
                class="gen_input noborder"
                id="gen_inputId91"
                name="gen_inputId91"
              />
            </div>
            <div
              id="gen_widgetId92"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                height: 16px;
                position: absolute;
                z-index: 100;
                width: 92px;
                top: 780.467px;
                left: 473.867px;
              "
            >
              <input
                type="text"
                class="gen_input noborder"
                id="gen_inputId92"
                name="gen_inputId92"
              />
            </div>
            <div
              id="gen_widgetId94"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                height: 16px;
                position: absolute;
                z-index: 104;
                width: 75px;
                top: 952.467px;
                left: 336px;
              "
            >
              <input
                type="text"
                class="gen_input noborder"
                id="gen_inputId94"
                name="gen_inputId94"
              />
            </div>
            <div
              id="gen_widgetId95"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                height: 16px;
                position: absolute;
                z-index: 102;
                width: 85px;
                top: 953.467px;
                left: 468.867px;
              "
            >
              <input
                type="text"
                class="gen_input noborder"
                id="gen_inputId95"
                name="gen_inputId95"
              />
            </div>
            <div
              id="gen_widgetId93"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                height: 48px;
                position: absolute;
                z-index: 103;
                width: 244px;
                top: 871.35px;
                left: 332px;
              "
            >
              <textarea
                style="resize: none"
                class="gen_input noborder"
                id="gen_inputId93"
                name="gen_inputId93"
              ></textarea>
            </div>
            <div
              id="gen_widgetId96"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 105;
                top: 471px;
                left: 578px;
              "
            >
              <input
                type="text"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId96"
                name="gen_inputId96"
              />
            </div>
            <div
              id="gen_widgetId97"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 106;
                top: 488px;
                left: 578px;
              "
            >
              <input
                type="text"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId97"
                name="gen_inputId97"
              />
            </div>
            <div
              id="gen_widgetId98"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 107;
                top: 505px;
                left: 578px;
              "
            >
              <input
                type="text"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId98"
                name="gen_inputId98"
              />
            </div>
            <div
              id="gen_widgetId99"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 113;
                top: 519px;
                left: 651px;
              "
            >
              <input
                type="text"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId99"
                name="gen_inputId99"
              />
            </div>
            <div
              id="gen_widgetId100"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 114;
                top: 535px;
                left: 651px;
              "
            >
              <input
                type="text"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId100"
                name="gen_inputId100"
              />
            </div>
            <div
              id="gen_widgetId101"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 115;
                top: 551px;
                left: 651px;
              "
            >
              <input
                type="text"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId101"
                name="gen_inputId101"
              />
            </div>
            <div
              id="gen_widgetId102"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 108;
                top: 610px;
                left: 578px;
              "
            >
              <input
                type="text"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId102"
                name="gen_inputId102"
              />
            </div>
            <div
              id="gen_widgetId103"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 116;
                top: 611px;
                left: 687px;
              "
            >
              <input
                type="text"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId103"
                name="gen_inputId103"
              />
            </div>
            <div
              id="gen_widgetId104"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 109;
                top: 642px;
                left: 578px;
              "
            >
              <input
                type="text"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId104"
                name="gen_inputId104"
              />
            </div>
            <div
              id="gen_widgetId105"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 110;
                top: 659px;
                left: 578px;
              "
            >
              <input
                type="text"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId105"
                name="gen_inputId105"
              />
            </div>
            <div
              id="gen_widgetId106"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 111;
                top: 697px;
                left: 578px;
              "
            >
              <input
                type="text"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId106"
                name="gen_inputId106"
              />
            </div>
            <div
              id="gen_widgetId107"
              class="gen-widget gen-xBox gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                width: 17px;
                height: 17px;
                position: absolute;
                z-index: 112;
                top: 737px;
                left: 578px;
              "
            >
              <input
                type="text"
                class="gen_input xBox"
                autocomplete="off"
                style="font-size: 13px"
                id="gen_inputId107"
                name="gen_inputId107"
              />
            </div>
            <div
              id="gen_widgetId108"
              class="gen-widget gen-layer3 gen-resize-destroyed gen-draggable-destroyed"
              style="
                height: 193px;
                position: absolute;
                z-index: 119;
                width: 246px;
                top: 780.35px;
                left: 580.867px;
              "
            >
              <textarea
                style="resize: none; font-size: 0.75rem; width: 245px; line-height: 1.2"
                class="gen_input noborder regular_input"
                id="gen_inputId108"
                name="gen_inputId108"
                v-model="values.otherTests"
              ></textarea>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.gen-widget {
  .gen_input {
    position: absolute;
    top: 0;
    left: 0;

    &.xBox {
      height: 13px;
      width: 13px;
      inset: 0;
      margin: auto;
    }
  }

  .structured_input {
    font-size: 0.8rem;
    letter-spacing: 13px;
    height: 16px;
    left: 4px;
  }
}
</style>
<script>
/* eslint-disable no-param-reassign */
import html2PDF from 'html2pdf.js';
import signature from '@/components/Prescription/signature-base64';
import bg from './labreq-base64';
import { formatHCN } from '../../utils/healthcard';
import { PROVINCE_ABBREV } from '../../constants/provinces';
import { formatAddress } from '../../utils/address';
import { generateUniqueId } from '../../utils/id';
import { uploadPatientFile } from '../../utils/file-upload';

export default {
  props: {
    partnerId: String,
  },
  data() {
    return {
      bg,
      signature,
    };
  },
  methods: {
    async createLabReq() {
      const labReqFile = await this.generatePdf();
      await uploadPatientFile({
        file: labReqFile,
        memberId: this.memberId,
        tags: ['TRUFORME'],
        metaData: [
          ...(this.partnerId ? [{ key: 'pendingPartnerId', valueString: this.partnerId }] : []),
        ],
        throwError: false,
      });

      this.$emit('success');
    },
    async generatePdf() {
      const { el: req } = this.$refs;
      req.classList.remove('component-slide-enter');
      req.classList.remove('component-slide-enter-active');
      const reqClone = req.cloneNode(true);

      reqClone.id = generateUniqueId();
      const el = document.createElement('div');
      el.style.width = '900px';
      el.style.height = '1100px';
      el.style.margin = '0px auto';
      el.style.position = 'relative';
      reqClone.style.position = 'absolute';
      reqClone.style.inset = '0';

      el.appendChild(reqClone);
      document.body.appendChild(el);
      Array.from(el.querySelectorAll('.structured_input')).forEach((input) => {
        const div = document.createElement('div');

        const text = input.value;
        const textAsArray = text.split('');
        textAsArray.forEach((char) => {
          const childDiv = document.createElement('div');
          childDiv.textContent = char;
          childDiv.style.width = '20px';
          childDiv.style.textAlign = 'center';
          div.appendChild(childDiv);
        });
        div.style.cssText = input.style.cssText;
        div.style.display = 'flex';
        div.style.flexWrap = 'nowrap';
        div.style.fontSize = '0.8rem';
        div.style.height = '16px';
        div.style.left = '0px';
        div.style.top = '0px';
        input.parentNode.insertBefore(div, input);
        input.remove();
      });

      Array.from(el.querySelectorAll('.regular_input')).forEach((input) => {
        const div = document.createElement('div');
        div.textContent = input.value;
        div.style.cssText = input.style.cssText;
        div.style.fontSize = input.style.fontSize || '0.8rem';
        div.style.lineHeight = input.style.lineHeight || '1';
        div.style.height = '16px';
        div.style.left = '4px';
        div.style.top = '0px';
        div.style.width = input.style.width || 'auto';
        input.parentNode.insertBefore(div, input);
        input.remove();
      });

      const output = await html2PDF()
        .set({
          jsPDF: { unit: 'mm', format: 'A4', orientation: 'p' },
          html2canvas: {
            useCORS: true,
            allowTaint: true,
            x: 0,
            y: 0,
            width: 850,
            height: 1200,
            windowWidth: 768,
            windowHeight: 600,
            dpi: 300,
            scale: 0.9,
            letterRendering: true,
          },
          margin: 0,
          image: {
            type: 'jpeg',
            quality: 0.98,
          },
        })
        .from(el, 'element')
        .toPdf()
        .get('pdf')
        .catch((e) => {
          console.log('error generating pdf: ', e);
        });

      const blob = output.output('blob');

      const file = new File(
        [blob],
        `LAB REQUISITION - ${this.patientLastName}, ${this.patientFirstName} - ${this.$store.getters
          .toTimezone()
          .format('YYYY-MM-DD')}.pdf`,
        { type: 'application/pdf' }
      );
      el.remove();
      return file;
    },
  },
  computed: {
    values() {
      if (this.isReturningPatient)
        return {
          additionalInfo: 'Follow-up',
          ohipInsured: true,
          tests: {
            glucose: true,
            hb1ac: true,
            creatinine: true,
            sodium: false,
            potassium: false,
            alt: false,
            lipid_assessment: true,
            fasting: true,
            cbc: false,
          },
          otherTests: '',
        };

      return {
        additionalInfo: 'Baseline',
        ohipInsured: true,
        tests: {
          glucose: true,
          hb1ac: true,
          creatinine: true,
          sodium: true,
          potassium: true,
          alt: true,
          lipid_assessment: true,
          fasting: true,
          cbc: true,
        },
        otherTests: 'Lipase',
      };
    },
    memberId() {
      return this.$store.state.registration.memberId;
    },
    isReturningPatient() {
      return this.$store.state.registration.isReturningPatient;
    },
    patientData() {
      return this.$store.state.registration.patientData;
    },
    hcn() {
      return (formatHCN(this.patientData.healthCard, false) || '').replaceAll('-', '');
    },
    sex() {
      return this.patientData.gender;
    },
    dob() {
      if (!this.patientData?.dateOfBirth) return '';
      return this.$store.getters.toTimezone(this.patientData.dateOfBirth).format('YYYYMMDD');
    },
    healthCardProvince() {
      if (!this.patientData?.healthCard?.province) return '';
      return PROVINCE_ABBREV[this.patientData.healthCard.province] || '';
    },
    patientLastName() {
      return this.patientData?.lastName || '';
    },
    patientFirstName() {
      return this.patientData?.firstName || '';
    },
    versionCode() {
      return this.patientData?.healthCard?.versionNumber || '';
    },
    patientPhone() {
      return this.patientData?.phone?.primary || '';
    },
    address() {
      if (!this.patientData?.mailingAddress) return [];
      return formatAddress(this.patientData.mailingAddress);
    },
  },
  mounted() {
    this.createLabReq();
  },
};
</script>
